module.exports = __webpack_public_path__ + "./img/analytics.88803e22bafafc57277c9b141532e3c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/mockups/analytics.jpg
// module id = ./public/img/mockups/analytics.jpg
// module chunks = 0